import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Page, PageHeader, Card, SearchInput, Badge, EmptyRow, Alert, Loading, initials } from '../../ui';
import { verificationTone } from '../../ui/staff';
import { api } from '../../ui/api';

const GROUPS = ['All', 'Pending', 'Action Required', 'Verified', 'Rejected'];

const StaffList = () => {
  const [staff, setStaff] = useState(null);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');
  const [group, setGroup] = useState('All');

  useEffect(() => {
    api('/staff/get_all_staff').then(setStaff).catch((e) => { setError(e.message); setStaff([]); });
  }, []);

  const q = query.toLowerCase();
  const inGroup = (s, g) => g === 'All' || (s.verification || 'Pending') === g;
  const rows = (staff || []).filter((s) => inGroup(s, group) && (
    s.name.toLowerCase().includes(q) || (s.phone_number || '').includes(query)
    || ((s.vendor_id && s.vendor_id.company_name) || '').toLowerCase().includes(q)));

  return (
    <Page>
      <PageHeader title="Field staff" subtitle="Technicians employed by vendors. New staff must be verified before they can sign in." />
      <Alert>{error}</Alert>
      <Card flush>
        <div className="toolbar">
          <SearchInput value={query} onChange={setQuery} placeholder="Search by name, phone or vendor" />
          <div className="chips">
            {GROUPS.map((g) => (
              <button key={g} className={`chip${g === group ? ' on' : ''}`} onClick={() => setGroup(g)}>
                {g}{staff ? ` · ${staff.filter((s) => inGroup(s, g)).length}` : ''}
              </button>
            ))}
          </div>
        </div>
        {!staff ? <Loading /> : (
          <div className="table-wrap">
            <table className="table stack-sm">
              <thead><tr><th>Name</th><th>Vendor</th><th>Phone</th><th>Verification</th><th>Can sign in</th><th /></tr></thead>
              <tbody>
                {rows.length ? rows.map((s) => (
                  <tr key={s.id}>
                    <td data-label="Name">
                      <div className="row" style={{ flexWrap: 'nowrap' }}>
                        <div className="avatar">{initials(s.name)}</div>
                        <div style={{ minWidth: 0 }}>
                          <Link to={`/staff/${s.id}`} className="strong">{s.name}</Link>
                          <span className="sub">{s.email}</span>
                        </div>
                      </div>
                    </td>
                    <td data-label="Vendor">{s.vendor_id ? s.vendor_id.company_name : '—'}</td>
                    <td data-label="Phone" className="nowrap">{s.phone_number}</td>
                    <td data-label="Verification"><Badge tone={verificationTone(s.verification)}>{s.verification || 'Pending'}</Badge></td>
                    <td data-label="Can sign in">{s.is_active ? 'Yes' : <span className="muted">No</span>}</td>
                    <td className="actions-cell">
                      <Link to={`/staff/${s.id}`} className="btn btn-secondary btn-sm">{s.verification === 'Pending' ? 'Review' : 'Open'}</Link>
                    </td>
                  </tr>
                )) : <EmptyRow cols={6}>{staff.length ? 'No staff match these filters.' : 'No field staff yet.'}</EmptyRow>}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </Page>
  );
};

export default StaffList;
